<template>
    <div class="container">
        <div class="top">
            <div class="content">
                <div class="left">
                    <router-link :to="{name: 'home'}">
                        <div class="logo"></div>
                    </router-link>
                </div>
                <div class="right">
                    <div class="social-media">
                      <a href="https://instagram.com/divasplayok" target="_blank">
                        <img src="/img/socials/instagram-40-gray.png" alt="instagram">
                      </a>
                      <a href="https://twitter.com/divasplayok" target="_blank">
                        <img src="/img/socials/twitter-40-gray.png" alt="twitter">
                      </a>
                      <a href="https://t.me/+LugFtFWsI5NkYWJh" target="_blank">
                        <img src="/img/socials/telegram-40-gray.png" alt="telegram">
                      </a>
                    </div>
                    <div class="language-selector">
                        <LanguageSelector/>
                    </div>
                </div>
            </div>
        </div>
        <div class="bottom">
            <router-link
                class="item"
                :to="{name: 'webstars.index'}"
            >
                {{$t('header.webstars')}}
            </router-link>
  
            <template v-if="$auth.ready() && $auth.check() && $auth.user().membership_active">
                <router-link
                  class="item"
                  :to="{name: 'category.index'}"
                >
                  DIVAS TV
                </router-link>
            </template>
<!--            <router-link-->
<!--                class="item faqs"-->
<!--                :to="{name: 'faqs'}"-->
<!--            >-->
<!--                {{$t('header.faqs')}}-->
<!--            </router-link>-->
            <template v-if="$auth.ready()">
                <template v-if="$auth.check()">
                    <router-link
                        class="item"
                        :to="{name: 'dashboard'}"
                    >
                        {{$t('header.dashboard')}}
                    </router-link>
                    <a
                        @click="$auth.logout()"
                        class="item special"
                    >
                        {{$t('header.logout')}}
                    </a>
                </template>
                <template v-else>
                    <router-link
                        class="item"
                        :to="{name: 'login'}"
                    >
                        {{$t('header.login')}}
                    </router-link>
                </template>
            </template>
            <template v-else>
                <a
                    class="item"
                    href="#"
                >
                    {{$t('loading')}}
                </a>
            </template>
  
            <template v-if="!($auth.ready() && $auth.check())">
              <a
                v-if="webstarsPanelUrl"
                class="item"
                :href="webstarsPanelUrl"
              >
                {{$t('header.webstars_panel')}}
              </a>
            </template>
        </div>
    </div>
</template>

<script>
import LanguageSelector from './Header.LanguageSelector';
import EventBus from '../eventbus';

export default {
    components: {
        LanguageSelector
    },
    data(){
        return {
            searchForm: {
                query: ''
            },
            webstarsPanelUrl: process.env.VUE_APP_WEBSTARS_PANEL_URL
        }
    },
    methods: {
        performSearch(event){
            this.$router.push({
                name: 'video.search',
                query: {
                    search: this.searchForm.search
                }
            });
        },
    }
}
</script>

<style scoped lang="scss">
@import '../styles/variables';

.top{
    background-color: lighten($pallete_dark_color, 15%);
    color: $pallete_clear_text_color;
    
    .logo{
        height: 44px;
        width: 465px;
        background-image: url('/img/logo-white.png');
        background-size: contain;
        background-position: left;
        background-repeat: no-repeat;
        
        
        @media(max-width: 900px){
            width: 100%;
            height: 44px;
            background-position: center;
        }
    }
    
    .content{
        padding: 20px;
        display: flex;
        flex-wrap: nowrap;
        justify-content: space-between;
        
        @media(max-width: 900px){
            flex-direction: column;
        }
        
        .left{
        
        }
        
        .right{
            flex-shrink: 1;
            display: flex;
            align-items: center;
  
            .social-media{
              display: flex;
              margin-right: 10px;
  
              @media(max-width: 900px){
                margin-right: 0;
              }
  
              a{
                display: flex;
                align-items: center;
                font-size: .8em;
                //margin-bottom: 5px;
                font-weight: bold;
                
                &:hover{
                  color: #ccc;
                }
                
                @media(max-width: 900px){
                  justify-content: center;
                }
    
                img{
                  width: 30px;
                  margin-left: 10px;
                  background: #000; // quitar
                }
              }
            }
            
            .search{
                @media(max-width: 900px){
                    width: 100%;
                    margin-top: 20px;
                }
                
                float: right;
                
                .search-bar{
                    position: relative;
                    
                    input{
                        position: relative;
                        background-color: lightgrey;
                        border: none;
                        padding: 8px 8px 8px /*calc(1em + 16px)*/ 8px;
                        font-size: 17px;
                        width: 100%;
                        
                        &:focus{
                            border: none;
                            box-shadow: none;
                            outline: none;
                        }
                    }
                    
                    .search-icon{
                        position: absolute;
                        cursor: pointer;
                        top: 7px;
                        bottom: 7px;
                        left: 7px;
                        width: 17px;
                        z-index: 999;
                        
                        &:after{
                            //content: '🔍'
                        }
                    }
                }
            }
            
            .language-selector{
                background-color: #000000;
                float: left;
                height: 36px;
                text-align: center;
                
                @media(max-width: 900px){
                    background-color: transparent;
                    display: block;
                }
            }
  
            @media(max-width: 900px){
                margin-top: 20px;
                flex-direction: row-reverse;
                justify-content: space-between;
    
                .social-media {
                    margin-right: 0;
                }
            }
        }
    }
}

.bottom{
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    
    @media(max-width: 768px){
        flex-direction: column;
    }
    
    background-color: #000000;
    color: #ffffff;
    
    .item{
        text-align: center;
        color: inherit;
        text-decoration: none;
        text-transform: uppercase;
        font-weight: bold;
        font-size: 16px;
        padding: .75em 0;
        flex-grow: 1;
        transition: background-color .2s ease-in-out;
        
        &.router-link-active{
            background-color: lighten(#000000, 50);
        }
        
        &:hover{
            background-color: lighten(#000000, 30);
        }
        
        &.special{
            background-color: $pallete_main_color;
            
            &:hover{
                background-color: lighten($pallete_main_color, 25);
            }
        }

        &.faqs{
          @media(max-width: 768px){
            display: none;
          }
        }
    }
}
</style>
